:host {
  display: flex;
  overflow-x: auto;
  background: var(--theme-tertiary-background);
  position: relative;
  --aha-image-selector--selected-background-color: var(--theme-input-focused-background);
  --aha-image-selector--selected-color: var(--aha-gray-900);
}

:host([aria-hidden='true']) {
  display: none;
}

slot::slotted(aha-image-selector-item) {
  --aha-image-selector-item--selected-background: var(
    --aha-image-selector--selected-background-color
  );
  --aha-image-selector-item--selected-color: var(--aha-image-selector--selected-color);
}
